import koalition from '../../../api/koalition'
import useFormBuilder from '../../../hooks/FormBuilderHook'
import Input from '../../forms/Input/Input'
import Validators from '../../../forms/Validators'
import { useModal } from '../../../contexts/Modal'
import { useEffect, useRef, useState } from 'react'
import { useToaster } from '../../../contexts/Toaster'
import { useCharacters } from '../../../contexts/Characters'
import useConfirmation from '../../../hooks/ConfimationHook'

const WriteAlliance = ({}) => {
    const modal = useModal()
    const toaster = useToaster()
    const characters = useCharacters()
    const formName = 'writeAlliance'
    const { alliance } = modal.$state.data || {}
    const { isMarked, markOrExecute } = useConfirmation()

    const writeAllianceRef = useRef()
    writeAllianceRef.current = () => {
        const formValues = form.$state.value
        formValues.server = characters.$state.current.server._id

        if (alliance) {
            koalition.put(`alliances/${alliance._id}`, formValues).then((response) => {
                modal.close()
                toaster.success('Alliance updated successfully')
            }).catch((error) => {
                toaster.error(error)
                console.error(error)
            })
        } else {
            koalition.post('alliances', formValues).then((response) => {
                modal.close()
                toaster.success('Alliance created successfully')
            }).catch((error) => {
                toaster.error(error)
                console.error(error)
            })
        }
    }

    const form = useFormBuilder({ formName, onSubmit: () => writeAllianceRef.current(), controls: {
        name: { validators: [Validators.required], value: alliance?.name },
        tag: { validators: [Validators.required, Validators.minLength(3), Validators.maxLength(3)], value: alliance?.tag },
    } })

    const deleteAlliance = () => {
        koalition.delete(`alliances/${alliance._id}`).then((response) => {
            modal.close()
            toaster.success('Alliance deleted successfully')
        }).catch((error) => {
            toaster.error(error)
            console.error(error)
        })
    }

    useEffect(() => {
        modal.configure({ formName, submitLabel: 'Save' })
    }, [])

    return (
        <div className="row justify-content-center">
            <div className="col-sm-8 mb-3">
                <Input control={form.$state.controls.name} label="Name" />
            </div>

            <div className="col-sm-4 mb-3">
                <Input control={form.$state.controls.tag} label="Tag" />
            </div>

            {alliance && (
                <div className="col-12 my-4">
                    <button type="button" className={`danger outline ${isMarked(alliance._id) ? 'marked' : ''} medium`} onClick={() => markOrExecute(alliance._id, deleteAlliance)}>
                        <span>Delete Alliance</span>
                    </button>
                </div>
            )}
        </div>
    )
}

export default WriteAlliance